import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../misc/guards/authenticated.guard';
import { PersonalDetailsPageComponent } from './personal-details.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: PersonalDetailsPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class PersonalDetailsPageRoutingModule {}
